// frontend/src/samkalp-admin/panels/BrandingPanel.js
import React from 'react';
import TenantBrandingPanel from '../../components/TenantAdmin/TenantBrandingPanel';

const BrandingPanel = ({ slug }) => (
    <TenantBrandingPanel tenantSlug={slug} />
);

export default BrandingPanel;
